import script from "./Post.vue?vue&type=script&setup=true&lang=js"
export * from "./Post.vue?vue&type=script&setup=true&lang=js"

import "./Post.vue?vue&type=style&index=0&id=73a3f742&scoped=true&lang=css"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a3f742"]])

export default __exports__